<ng-content select="[button]"></ng-content>
<div class="vl-modal">
  <dialog
    #modalRef
    [id]="id"
    class="vl-modal-dialog"
    [ngClass]="{ 'vl-modal-dialog--large': large }"
    data-vl-modal
    role="document"
    [attr.data-vl-modal-closable]="closable ? '' : null"
    tabindex="-1"
    role="dialog"
    aria-modal="true"
    aria-hidden="true"
    attr.aria-labelledby="modal-{{ id }}-title"
  >
    <div class="vl-modal-dialog__wrapper">
      <div class="vl-modal-dialog__header">
        <h2 class="vl-modal-dialog__title" id="modal-{{ id }}-title">
          {{ title }}
        </h2>
        <button
          class="vl-button vl-button--icon vl-button--naked-action vl-modal-dialog__close vl-modal-dialog__close"
          type="button"
          data-vl-modal-close
        >
          <span
            class="vl-icon vl-vi vl-vi-cross vl-button__icon"
            aria-hidden="true"
          ></span
          ><span class="labelClasses"
            ><span class="vl-u-visually-hidden">Sluiten</span></span
          >
        </button>
      </div>
      <ng-content select="[body]"></ng-content>
    </div>
  </dialog>
</div>
